import type { HullClass, HullConfig } from '../types/ship.ts';

export const HULLS_CONFIG: Record<HullClass, HullConfig> = {
  corvette: {
    id: 'corvette',
    name: 'Tiểu Hạm Corvette (Tia Chớp)',
    description: 'Thân tàu nhẹ siêu cơ động, thích hợp quấy rối sườn và trinh sát.',
    base_hp: 400,
    base_capacity: 70,
    base_energy: 60,
    base_armor: 15,
    base_shield: 50,
    base_speed: 160,
    base_evasion: 25,
    max_weapon_slots: 3,
    max_defense_slots: 2,
    max_engine_slots: 1,
    cost: { metal: 100, he3: 50, credits: 20 },
    build_time_sec: 20,
  },
  frigate: {
    id: 'frigate',
    name: 'Khinh Hạm Frigate (Tiên Phong)',
    description: 'Chiến hạm cân bằng tiêu chuẩn, lực lượng chủ lực trong mọi hạm đội.',
    base_hp: 950,
    base_capacity: 150,
    base_energy: 140,
    base_armor: 35,
    base_shield: 120,
    base_speed: 120,
    base_evasion: 15,
    max_weapon_slots: 5,
    max_defense_slots: 4,
    max_engine_slots: 2,
    cost: { metal: 240, he3: 130, credits: 50 },
    build_time_sec: 45,
  },
  destroyer: {
    id: 'destroyer',
    name: 'Khu Trục Hạm Destroyer (Hủy Diệt)',
    description: 'Trọng pháo chiến hạm chuyên săn lùng và tiêu diệt các tàu cỡ lớn.',
    base_hp: 2200,
    base_capacity: 320,
    base_energy: 280,
    base_armor: 60,
    base_shield: 250,
    base_speed: 95,
    base_evasion: 8,
    max_weapon_slots: 7,
    max_defense_slots: 6,
    max_engine_slots: 2,
    cost: { metal: 600, he3: 350, credits: 140 },
    build_time_sec: 90,
  },
  cruiser: {
    id: 'cruiser',
    name: 'Tuần Dương Hạm Cruiser (Pháo Đài)',
    description: 'Kỳ hạm bọc giáp siêu dày với hỏa lực áp đảo toàn bộ chiến trường.',
    base_hp: 4800,
    base_capacity: 620,
    base_energy: 550,
    base_armor: 110,
    base_shield: 500,
    base_speed: 70,
    base_evasion: 3,
    max_weapon_slots: 10,
    max_defense_slots: 8,
    max_engine_slots: 3,
    cost: { metal: 1400, he3: 850, credits: 350 },
    build_time_sec: 180,
  },
};
